import { render, staticRenderFns } from "./admin-template.vue?vue&type=template&id=56fa5fd6"
import script from "./admin-template.vue?vue&type=script&lang=js"
export * from "./admin-template.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports